import { useAuth } from 'auth/AuthContext';
import Login from 'components/Login';

// Bloque l'accès à l'application tant que l'utilisateur n'est pas authentifié
// (fonctionne à l'identique sur les versions mobile et desktop, gérées ensuite par Rentman).
function AuthGate({ children }) {
  const { isAuthenticated, checkingSession } = useAuth();

  if (checkingSession) return null;
  if (!isAuthenticated) return <Login />;
  return children;
}

export default AuthGate;
